import { ISection } from 'store/modules/goal/types'

import { DailyGoalMode, DailyGoalValues } from '../types'
import { buildManualDailyGoals, SubmittedDailyGoal } from './dailyGoals'
import { SubmittedGoalConfig, SubmittedMonthGoal, SubmittedUserWorking } from './submittedGoalConfig'

interface BuildGoalPayloadProps {
  config: SubmittedGoalConfig
  dailyGoalMode: Exclude<DailyGoalMode, null>
  dailyGoalValues?: DailyGoalValues
  month: string
  storeId: string
}

export interface BulkGoalPayload {
  config: {
    active: boolean
    commission: { fixed: { commission: number; type: 'user' }; storeSold: boolean }
    dailyGoalMode?: 'manual'
    firstActivation: boolean
    suggestion: boolean
  }
  days: SubmittedDailyGoal[]
  distribute: boolean
  dsr: number
  mainGoals: { price: number; ticket: number; total: number }
  month: string
  monthGoals: SubmittedMonthGoal[]
  salary: { base: number; complement: boolean; directCommission: boolean; splitCommission: boolean }
  sections: ISection[]
  storeId: string
  updateInputs: boolean
  usersWorking: SubmittedUserWorking[]
}

export const buildGoalPayload = ({
  config,
  dailyGoalMode,
  dailyGoalValues = {},
  month,
  storeId
}: BuildGoalPayloadProps): BulkGoalPayload => {
  const isManual = dailyGoalMode === 'manual'

  return {
    config: {
      active: false,
      commission: { fixed: { commission: config.fixedCommission, type: 'user' }, storeSold: config.storeSold },
      ...(isManual ? { dailyGoalMode: 'manual' as const } : {}),
      firstActivation: false,
      suggestion: dailyGoalMode === 'ai'
    },
    days: isManual
      ? buildManualDailyGoals({ storeId, usersWorking: config.usersWorking, values: dailyGoalValues })
      : [],
    distribute: config.distribute,
    dsr: config.dsr,
    mainGoals: config.mainGoals,
    month,
    monthGoals: config.monthGoals,
    salary: config.salary,
    sections: config.sections,
    storeId,
    updateInputs: true,
    usersWorking: config.usersWorking
  }
}
